import { useNavigate } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import {
	Box,
	Container,
	Paper,
	Typography,
	Button,
	Stack
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface ErrorPageProps {
	statusCode?: string;
}

export default function ErrorPage(props: ErrorPageProps) {
	const navigate = useNavigate();
	const { isAuthenticated } = useAuth0();

	const goHome = () => {
		let path = isAuthenticated ? '/plan' : '/';
		navigate(path);
	};

	let errorMsg = "";
	if (props.statusCode === '503') {
		errorMsg = "This Page is under Construction";
	} else if (props.statusCode === '500') {
		errorMsg = "There is problem with request, Try again later!";
	} else if (props.statusCode === "505") {
		errorMsg = "You have already submit survey with this email!";
	}

	return (
		<Container 
			maxWidth={false}
			sx={{ 
				height: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: {
					xs: '100%',    // Full width on mobile
					sm: '100%',    // Full width on tablet
					md: '66.67%',  // 2/3 width on medium screens
					lg: '33.33%',  // 1/3 width on large screens
				},
				mx: 'auto'
			}}
		>
			<Paper 
				elevation={0}
				sx={{
					p: 4,
					textAlign: 'center',
					borderRadius: 1
				}}
			>
				<Stack spacing={3} alignItems="center">
					<ErrorOutlineIcon 
						sx={{ 
							fontSize: 64,
							color: 'error.main'
						}} 
					/>
					
					<Typography variant="h2">
						{props.statusCode || "404"}
					</Typography>

					<Typography variant="h6">
						{errorMsg || "This page does not exist"}
					</Typography>

					<Button 
						variant="contained"
						onClick={goHome}
						sx={{ mt: 2 }}
					>
						Home
					</Button>
				</Stack>
			</Paper>
		</Container>
	);
}
